var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { attrs: { "no-body": "", header: _vm.header } },
    [
      _c(
        "b-card-body",
        [
          _c("img", {
            attrs: {
              alt: "Snyk logo",
              src: require("@/assets/img/snyk-logo.png"),
              height: "128px",
            },
          }),
          _c("hr"),
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: {
                  disabled:
                    !this.scannerEnabled &&
                    (!this.baseUrl ||
                      !this.orgId ||
                      !this.apitoken ||
                      !this.apiVersion),
                  id: "scannerEnabled",
                  color: "primary",
                  label: "",
                },
                model: {
                  value: _vm.scannerEnabled,
                  callback: function ($$v) {
                    _vm.scannerEnabled = $$v
                  },
                  expression: "scannerEnabled",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(
            "\n    " + _vm._s(_vm.$t("admin.analyzer_snyk_enable")) + "\n    "
          ),
          _c("br"),
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: {
                  disabled: !this.scannerEnabled,
                  id: "aliasSyncEnabled",
                  color: "primary",
                  label: "",
                  title: _vm.$t("admin.vulnsource_alias_sync_enable_tooltip"),
                },
                model: {
                  value: _vm.aliasSyncEnabled,
                  callback: function ($$v) {
                    _vm.aliasSyncEnabled = $$v
                  },
                  expression: "aliasSyncEnabled",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("admin.vulnsource_alias_sync_enable")) +
              "\n    "
          ),
          _c("p", { staticClass: "font-sm text-muted" }, [
            _c("span", { staticClass: "fa fa-warning" }, [_vm._v(" ")]),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("admin.analyzer_snyk_alias_sync_warning")) +
                "\n    "
            ),
          ]),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "snyk-baseUrl",
              label: _vm.$t("admin.base_url"),
              "input-group-size": "mb-3",
              rules: "required",
              lazy: "true",
            },
            model: {
              value: _vm.baseUrl,
              callback: function ($$v) {
                _vm.baseUrl = $$v
              },
              expression: "baseUrl",
            },
          }),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "snyk-orgId",
              label: _vm.$t("admin.analyzer_snyk_org_id"),
              "input-group-size": "mb-3",
              rules: "required",
              lazy: "true",
            },
            model: {
              value: _vm.orgId,
              callback: function ($$v) {
                _vm.orgId = $$v
              },
              expression: "orgId",
            },
          }),
          _c("p", { staticClass: "font-sm text-muted" }, [
            _c("span", { staticClass: "fa fa-question-circle" }, [_vm._v(" ")]),
            _c("a", { attrs: { href: _vm.findOrgIdUrl, target: "_blank" } }, [
              _vm._v(_vm._s(_vm.$t("admin.analyzer_snyk_how_to_org_id_help"))),
            ]),
          ]),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "snyk-apitoken",
              label: _vm.$t("admin.api_token"),
              "input-group-size": "mb-3",
              rules: "required",
              type: "password",
              lazy: "true",
            },
            model: {
              value: _vm.apitoken,
              callback: function ($$v) {
                _vm.apitoken = $$v
              },
              expression: "apitoken",
            },
          }),
          _c("p", { staticClass: "font-sm text-muted" }, [
            _c("span", { staticClass: "fa fa-question-circle" }, [_vm._v(" ")]),
            _c(
              "a",
              { attrs: { href: _vm.findApiTokenUrl, target: "_blank" } },
              [
                _vm._v(
                  _vm._s(_vm.$t("admin.analyzer_snyk_how_to_api_token_help"))
                ),
              ]
            ),
            _c("br"),
            _c("span", { staticClass: "fa fa-info-circle" }),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("admin.analyzer_snyk_multiple_tokens_info"))
            ),
            _c("code", [_vm._v("token1;token2")]),
          ]),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "snyk-apiVersion",
              label: _vm.$t("admin.analyzer_snyk_api_version"),
              "input-group-size": "mb-3",
              rules: "required",
              lazy: "true",
            },
            model: {
              value: _vm.apiVersion,
              callback: function ($$v) {
                _vm.apiVersion = $$v
              },
              expression: "apiVersion",
            },
          }),
          _c("p", { staticClass: "font-sm text-muted" }, [
            _c("span", { staticClass: "fa fa-question-circle" }, [_vm._v(" ")]),
            _c("a", { attrs: { href: _vm.apiDocsUrl, target: "_blank" } }, [
              _vm._v(
                _vm._s(_vm.$t("admin.analyzer_snyk_how_to_api_version_help"))
              ),
            ]),
            _c("br"),
            _c("span", { staticClass: "fa fa-warning" }),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("admin.analyzer_snyk_api_version_warning")) +
                "\n    "
            ),
          ]),
          _c(
            "b-row",
            { staticStyle: { "margin-top": "2rem" } },
            [
              _c(
                "b-col",
                { attrs: { sm: "6" } },
                [
                  _c("b-form-group", {
                    attrs: { label: _vm.$t("message.cvss_source") },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ cvssSource }) {
                          return [
                            _c("b-form-radio-group", {
                              staticClass: "cvss-calc cvss-calc-3-btn",
                              attrs: {
                                options: _vm.cvssOptions,
                                "aria-describedby": cvssSource,
                                name: "radios-btn-default",
                                "button-variant": "outline-primary",
                                buttons: "",
                              },
                              on: { change: _vm.generateCvssV2Vector },
                              model: {
                                value: _vm.cvssSourceSelected,
                                callback: function ($$v) {
                                  _vm.cvssSourceSelected = $$v
                                },
                                expression: "cvssSourceSelected",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("p", { staticClass: "font-sm text-muted" }, [
            _c("span", { staticClass: "fa fa-question-circle" }, [_vm._v(" ")]),
            _c(
              "a",
              { attrs: { href: _vm.multipleCvssDocs, target: "_blank" } },
              [_vm._v(_vm._s(_vm.$t("admin.analyzer_snyk_why_multiple_cvss")))]
            ),
          ]),
          _c("hr"),
          _c("p", [_vm._v(_vm._s(_vm.$t("admin.analyzer_snyk_desc")))]),
        ],
        1
      ),
      _c(
        "b-card-footer",
        [
          _c(
            "b-button",
            {
              staticClass: "px-4",
              attrs: {
                disabled:
                  !this.baseUrl ||
                  !this.orgId ||
                  !this.apitoken ||
                  !this.apiVersion,
                variant: "outline-primary",
              },
              on: { click: _vm.saveChanges },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("message.update")) + "\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }